import { GetProductList as _GetProductList, GetCustomerLlist as _GetCustomerLlist } from '@/api/orderManage/orderManage';
var state = {};
var mutations = {};
var actions = {
  GetProductList: function GetProductList(commit, data) {
    return new Promise(function (resolve, reject) {
      _GetProductList(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  GetCustomerLlist: function GetCustomerLlist(commit, data) {
    return new Promise(function (resolve, reject) {
      _GetCustomerLlist(data).then(function (res) {
        resolve(res);
      }).catch(function (error) {
        reject(error);
      });
    });
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};